// Central config for verticals (Imóveis / Médicos / Automóveis)
// Keeps kind labels, filters and route slugs in one place.

import { Home, HeartPulse, Car } from "lucide-react";

export const VERTICALS = {
  real_estate: {
    key: "real_estate",
    label: "Guia Imóveis",
    planLabel: "Guia Imóveis",
    singular: "Imóvel",
    icon: Home,
    listRoute: "/imoveis",
    profileRoute: "/corretor",           // /corretor/:slug
    detailRoute: "/imoveis",             // /imoveis/:slug
    plan: "imoveis_pro",
    color: "hsl(213 90% 55%)",
    kinds: [
      { key: "venda", label: "Venda" },
      { key: "aluguel", label: "Aluguel" },
      { key: "temporada", label: "Temporada" },
      { key: "lancamento", label: "Lançamento" },
    ],
    fields: [
      { key: "type", label: "Tipo", placeholder: "Casa, apto, sala..." },
      { key: "bedrooms", label: "Quartos", type: "number" },
      { key: "bathrooms", label: "Banheiros", type: "number" },
      { key: "parking", label: "Vagas", type: "number" },
      { key: "area", label: "Área (m²)", type: "number" },
      { key: "neighborhood", label: "Bairro" },
      { key: "condo", label: "Condomínio (R$)", type: "number" },
      { key: "iptu", label: "IPTU (R$)", type: "number" },
    ],
    profileFields: [
      { key: "creci", label: "CRECI", short: "CRECI" },
      { key: "specialties", label: "Especialidades (separe por vírgula)", short: "Especialidades" },
      { key: "regions", label: "Regiões de atuação", short: "Atua em" },
    ],
  },
  health: {
    key: "health",
    label: "Guia Médicos",
    planLabel: "Guia Médicos",
    singular: "Publicação",
    icon: HeartPulse,
    listRoute: "/medicos",
    profileRoute: "/medico",             // /medico/:slug
    detailRoute: "/medicos-publicacao",  // /medicos-publicacao/:slug
    plan: "medicos_pro",
    color: "hsl(160 70% 45%)",
    kinds: [
      { key: "artigo", label: "Artigo educativo" },
      { key: "servico", label: "Serviço / Consulta" },
      { key: "campanha", label: "Campanha" },
    ],
    fields: [
      { key: "duration", label: "Duração (min)", type: "number" },
      { key: "modality", label: "Modalidade", placeholder: "Presencial / Online" },
    ],
    profileFields: [
      { key: "crm", label: "CRM", short: "CRM" },
      { key: "specialty", label: "Especialidade", short: "Especialidade" },
      { key: "insurances", label: "Convênios aceitos (vírgula)", short: "Convênios" },
      { key: "clinic", label: "Clínica / Consultório", short: "Clínica" },
    ],
  },
  automotive: {
    key: "automotive",
    label: "Guia Auto",
    planLabel: "Guia Auto",
    singular: "Veículo",
    icon: Car,
    listRoute: "/veiculos",
    profileRoute: "/loja-veiculos",      // /loja-veiculos/:slug
    detailRoute: "/veiculos",            // /veiculos/:slug
    plan: "auto_pro",
    color: "hsl(24 95% 55%)",
    kinds: [
      { key: "usado", label: "Usado" },
      { key: "novo", label: "0 km" },
      { key: "seminovo", label: "Seminovo" },
    ],
    fields: [
      { key: "brand", label: "Marca" },
      { key: "model", label: "Modelo" },
      { key: "year", label: "Ano", type: "number" },
      { key: "km", label: "KM", type: "number" },
      { key: "fuel", label: "Combustível", placeholder: "Flex/Diesel/Elétrico" },
      { key: "gearbox", label: "Câmbio", placeholder: "Manual/Automático" },
      { key: "color", label: "Cor" },
    ],
    profileFields: [
      { key: "brands", label: "Marcas trabalhadas (vírgula)", short: "Marcas" },
      { key: "type", label: "Tipo de loja", placeholder: "Multimarcas / Concessionária", short: "Tipo" },
      { key: "financing", label: "Financiamento", placeholder: "Sim / Não", short: "Financiamento" },
    ],
  },
};

export const VERTICAL_LIST = Object.values(VERTICALS);

export function verticalOf(plan) {
  const found = VERTICAL_LIST.find((v) => v.plan === plan);
  return found?.key || null;
}

export function fmtBRL(n) {
  const v = Number(n);
  if (!isFinite(v) || v <= 0) return "Sob consulta";
  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}
